"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var preact_router_1 = require("preact-router");
var header_1 = __importDefault(require("./header/header"));
var home_1 = __importDefault(require("../routes/home/home"));
var profile_1 = __importDefault(require("../routes/profile/profile"));
var App = (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRoute = function (e) {
            _this.currentUrl = e.url;
        };
        return _this;
    }
    App.prototype.render = function () {
        return (preact_1.h("div", { id: "app" },
            preact_1.h(header_1.default, null),
            preact_1.h(preact_router_1.Router, { onChange: this.handleRoute },
                preact_1.h(home_1.default, { path: "/" }),
                preact_1.h(profile_1.default, { path: "/profile/", user: "me" }),
                preact_1.h(profile_1.default, { path: "/profile/:user" }))));
    };
    return App;
}(preact_1.Component));
exports.default = App;
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./components/app.js